var $2b06a5c996370ce9$export$e9d9376124133876 = /*#__PURE__*/ function(LocalStorageKey) {
    LocalStorageKey["UI_LANGUAGE"] = "ui-language";
    LocalStorageKey["ACTIVE_ORGANIZATION_ID"] = "active-organization-id";
    return LocalStorageKey;
}({});


var $df18c473acc82d0d$export$ce4fe1c9e6520c1a = /*#__PURE__*/ function(Language) {
    Language["DE"] = "de";
    Language["FR"] = "fr";
    Language["IT"] = "it";
    Language["EN"] = "en";
    return Language;
}({});
const $df18c473acc82d0d$export$910b680d1eea6990 = "de";
const $df18c473acc82d0d$export$bb3745f2aff4bee8 = (language)=>{
    return Object.values($df18c473acc82d0d$export$ce4fe1c9e6520c1a).includes(language);
};
const $df18c473acc82d0d$export$e3a1d3fb35f16635 = (languageAsString)=>{
    switch(languageAsString){
        case "de":
            return "de";
        case "en":
            return "en";
        case "fr":
            return "fr";
        case "it":
            return "it";
        default:
            console.warn(`Tried to parse unknown language ${languageAsString}`);
            return $df18c473acc82d0d$export$910b680d1eea6990;
    }
};


const $ac22c520641e1d57$export$ed0387b2892e759a = ()=>{
    try {
        // first check if something is stored in local storage
        const localStorageLanguage = localStorage.getItem((0, $2b06a5c996370ce9$export$e9d9376124133876).UI_LANGUAGE);
        if (localStorageLanguage) {
            if ((0, $df18c473acc82d0d$export$bb3745f2aff4bee8)(localStorageLanguage)) return localStorageLanguage;
            else console.warn(`There was an unsupported language (${localStorageLanguage}) in local storage`);
        }
        // if nothing useful is found, check for navigator languages
        if (!navigator || !navigator.languages) return 0, $df18c473acc82d0d$export$910b680d1eea6990;
        return navigator.languages// e.g. from ['de-CH', 'de', 'de-DE', 'en', 'en-GB', 'es-US'] to ['de', 'de', 'de', 'en', 'en', 'es']
        .map((localizedLanguage)=>localizedLanguage.split('-')[0])// take first language that is supported from application. Otherwise, return default
        .find((language)=>(0, $df18c473acc82d0d$export$bb3745f2aff4bee8)(language)) || (0, $df18c473acc82d0d$export$910b680d1eea6990);
    } catch (e) {
        console.error(e);
        return 0, $df18c473acc82d0d$export$910b680d1eea6990;
    }
};
const $ac22c520641e1d57$export$61465194746e7fd2 = (languageAsString, baseHref, replace = false, location = window.location)=>{
    const language = (0, $df18c473acc82d0d$export$e3a1d3fb35f16635)(languageAsString);
    localStorage.setItem((0, $2b06a5c996370ce9$export$e9d9376124133876).UI_LANGUAGE, language);
    const index = baseHref.indexOf('/', 1);
    if (index !== -1) baseHref = baseHref.substring(0, index + 1);
    let currentPath = $ac22c520641e1d57$export$1fa9f92a868417a7(location);
    if (currentPath.replaceAll('/', '') === baseHref.replaceAll('/', '')) // the path is the same as the baseHref (so the defined --base-href is expected), we add a slash so that the URL ends with one
    currentPath = '/';
    else if ($ac22c520641e1d57$var$getLanguageStringFromPath(currentPath) !== '') // remove everything up to the current language sub path
    currentPath = currentPath.slice(baseHref.length + 2);
    // the new path should preserve path elements like query params, hashes or other route information.
    const newPath = `${baseHref}${language}${currentPath}`;
    // required for initial routing. We don't want the user being able to go back to language-router mini app
    if (replace) location.replace(newPath);
    else location.href = newPath;
};
const $ac22c520641e1d57$var$getLanguageStringFromPath = (path)=>{
    // Split the path into segments
    const segments = path.split('/').filter((segment)=>segment.length > 0);
    for (const segment of segments){
        if ((0, $df18c473acc82d0d$export$bb3745f2aff4bee8)(segment)) return segment;
    }
    return '';
};
const $ac22c520641e1d57$export$1fa9f92a868417a7 = (location = window.location)=>{
    const protocol = location.protocol;
    const host = location.host;
    const href = location.href;
    return href.replace(`${protocol}//${host}`, '');
};
const $ac22c520641e1d57$export$3ea414becaa742eb = ()=>{
    const currentPath = $ac22c520641e1d57$export$1fa9f92a868417a7();
    // if current path contains language, language is one and two characters after the baseHref (e.g. /static/de/transactions)
    const pathLang = $ac22c520641e1d57$var$getLanguageStringFromPath(currentPath);
    if (pathLang !== '') return (0, $df18c473acc82d0d$export$e3a1d3fb35f16635)(pathLang);
    // this is the case when developing locally
    return undefined;
};


// get language to route to and then route to that language, storing the information to local storage
const $c73f67987a192ac3$var$initialLanguage = (0, $ac22c520641e1d57$export$ed0387b2892e759a)();
(0, $ac22c520641e1d57$export$61465194746e7fd2)($c73f67987a192ac3$var$initialLanguage, '/static/', true);


//# sourceMappingURL=language-router.ed42a037.js.map
